<template>
    <div
        class="homepageGraphic__circleElement circleElement"
        :class="`-${currentKey}`"
    >
        <div class="circleElement__inner">
            <h2 class="circleElement__title" v-html="animationTitle">
            </h2>
            <p class="circleElement__intro" v-html="animationIntro"></p>
            <div class="circleElement__notches">
                <div
                    v-for="(word, index) in countInWords"
                    :key="word"
                    ref="circleNotch"
                    class="circleElement__notch"
                    :class="`-${word}`"
                    :aria-label="`${getTitle(index)}`"
                    tabindex="0"
                    @click="updateCurrentKeyManual( index + 1)"
                    @keyup.enter="updateCurrentKeyManual( index + 1)"
                >
                    <span
                        ref="circlePulse"
                        class="circleElement__pulse"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import converter from 'number-to-words'
import anime from 'animejs/lib/anime.es.js'


export default {
    data () {
        return {
            pulseEntrance: null,
        }
    },
    props: ['animationTitle', 'animationIntro'],
    computed: {
        ...mapState(['currentKey']),
        ...mapState(['inView']),
        ...mapGetters(['keyedData']),
        ...mapGetters(['currentData', 'getTitle']),

        title () {
            return this.currentData.title
        },

        countInWords () {
            return Object.keys(this.keyedData).map(key => key)
        },
    },
    watch: {
        inView (val) {
            if (val === true) {
                this.pulseEntrance.play()
            }
        },
    },

    mounted () {
        this.createPulseEntrance()
        this.$store.dispatch('getImpact')
    },

    methods: {
        updateCurrentKeyManual (key) {
            const current = converter.toWords(key)
            this.$store.dispatch('setCurrentKey', current)
        },

        createPulseEntrance () {
            this.pulseEntrance = anime({
                targets: this.$refs.circlePulse,
                duration: 1000,
                easing: 'easeOutQuart',
                delay: anime.stagger(200),
                opacity: 0,
                scaleX: 5,
                scaleY: 5,
                loop: false,
                autoplay: false,
            })
        },

        scrollToFrame (key, point) {
            const scrollDistance = window.pageYOffset
            const containerRectTop = document.querySelector('.js-homepageGraphic').getBoundingClientRect().top
            const containerFromTop = scrollDistance + containerRectTop
            const scrollPoint = (containerFromTop + (point * 664)) - 332

            window.scrollTo({
                top: scrollPoint,
                left: 0,
                behavior: 'smooth',
            })
        },
    },

}
</script>
